import { useQuery } from '@tanstack/react-query'
import { tenantsApi } from '../api'

export function useTenantOrganizations(tenantId: string | undefined) {
  return useQuery({
    queryKey: ['tenant-organizations', tenantId],
    queryFn: async () => {
      if (!tenantId) throw new Error('Tenant ID is required')
      const response = await tenantsApi.getOrganizations(tenantId)
      return response.data.data.organizations
    },
    enabled: !!tenantId,
  })
}
